export default class validacionActaNacimiento {
    constructor(
        public cedulaAfiliado?: string,
        public nombreAfiliado?: string,
        public fechaNacimientoAfiliado?: string,
        public rutaActaNacimiento?: string,
    ) {}
}

class ValidacionActaNacimientoResp {
    constructor(
        public nombreCoincide?: boolean,
        public fechaNacimientoCoincide?: boolean,
    ) {}
}

export {ValidacionActaNacimientoResp}